<template>
    <mySubPage>
        <div slot="header">
            <myNav>批量话费充值</myNav>
            <div class="flex-box">
                <div class="width-400 flex-box nopadding">
                    <div class="flex-box-bd tleft">
                        <a class="link" @click="downExcel">下载模板</a>
                    </div>
                    <myExcelToJson @change="onUpExcel">
                        <el-button size="small" type="primary">导入表格</el-button>
                    </myExcelToJson>
                </div>
                <div class="width-20"></div>
                <div class="flex-box-bd tleft flex-box nopadding">
                    <div class="flex-box-bd tleft">
                        <my-sub-title>选择充值套餐</my-sub-title>
                    </div>
                    <div class="f-blue f-bd">
                        当前单量：{{order_qty}}个
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-box fillh pd-top0">
            <div class="width-400 fillh">
                <el-input class="fillh" type="textarea" v-model="str_items" @input="onItemChange"
                          placeholder="请输入或导入手机号码，一个手机号码一行，单次最多1000个"></el-input>
            </div>
            <div class="width-20"></div>
            <div class="flex-box-bd fillh">
                <div class="flex-box nopadding wrap" v-if="goods.length > 0">
                    <div class="card-box bg2 round-10 width-250 mg-right10 mg-bottom10 hand hover-block" style="height: 100px"
                         v-for="(item,index) in goods" :key="item.goods_id" @click="add(item)">
                        <div class="flex-box pd-5" v-if="item.img_lnk != ''">
                            <div class="width-80">
                                <img class="img-80 round-5" :src="item.img_lnk">
                            </div>
                            <div class="flex-box-bd tleft mg-left5 over-hide">
                                <div class="f-bd text-nowrap">{{item.goods_cname}}</div>
                                <div class="f-red mg-top10" v-if="item.cost_amt != ''">
                                    <span class="f18 mg-right3">{{item.cost_amt * 1}}</span>元
                                </div>
                            </div>
                        </div>
                        <div class="flex-box col-center fillh" v-else>
                            <div class="flex-box-bd"></div>
                            <div class="f-bd text-nowrap">{{item.goods_cname}}</div>
                            <div class="f-red mg-top10" v-if="item.cost_amt != ''">
                                <span class="f18 mg-right3">{{item.cost_amt * 1}}</span>元
                            </div>
                            <div class="flex-box-bd"></div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <myNodata></myNodata>
                </div>
            </div>
        </div>
    </mySubPage>
</template>

<script>
import myExcelToJson from '../../../components/myExcelToJson'
import myNodata from '../../../components/myNodata'
import table2excel from "js-table2excel";
export default {
    components:{
        myNodata,
        myExcelToJson
    },
    data:function(){
        return{
            formData:{
                goods_id:'',
                goods_amt:'',
                items:[],
            },
            goods:[],
            order_qty: 0,
            str_items:"" //手机号码字符串
        }
    },
    mounted: function(){
        this.$parent.$parent.show_subview = true;
        this.getLoad();
    },
    methods:{
        cancel: function(){
            this.$base.linkBack();
        },
        downExcel:function (){
            table2excel([{
                title:'手机号码'
            }], [], '批次导入模板');
        },
        onUpExcel:function(data){
            if(data.length > 3000){
                this.$base.alertErr('一批次最多上传3000个手机号码，当前表格超出限制');
                return;
            }
            this.order_qty = data.length;
            this.str_items = data.join("\n");
        },
        onItemChange:function (){
            var items = this.str_items.split('\n');
            this.order_qty = items.length;
        },
        getLoad: function(){
            this.$base.showLoading();
            this.$request.sendPost("order-c-bat/before-add", {},(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.goods = data.goods;
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        add: function(item){
            this.str_items = this.str_items.trim();
            if(this.str_items == ''){
                this.$base.alertErr('请导入或输入手机号码');
                return;
            }
            this.formData.items = this.str_items.split('\n');
            this.order_qty = this.formData.items.length;
            if(this.order_qty > 3000){
                this.$base.alertErr('一批次最多处理3000个手机号码，当前上传已超出限制');
                return;
            }

            this.$base.confirm('确认给'+this.order_qty + '个手机号，各充值：'+(item.new_price * 1)+'元',()=>{
                this.formData.goods_id = item.goods_id;
                this.formData.goods_amt = item.new_price;
                this.$base.showLoading();
                this.$request.sendPost("order-c-bat/add", this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.alertSuccess('下单成功，批次号：' + data,()=>{
                            this.relist = true;
                            this.$base.linkBack();
                        });
                    }
                    else{
                        this.$base.alertErr(error.errmsg + '；批量执行，有可能网络超时，请人工检查订单列表，确认是否成功！');
                    }
                });
            });
        }
    },
    beforeDestroy: function () {
        this.$parent.$parent.show_subview = false;
        this.$parent.$parent.relist = this.relist;
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/charge/mobilebat/save.vue